<template>
  <v-row no-gutters :style="{ 'min-height': '100vh' }">
    <v-col cols="12" md="8" offset-md="2" lg="6" offset-lg="3" xl="4" offset-xl="4" class="pa-4">
      <div class="mt-10">
        <div class="text-center" style="height: 150px;">
          <lottie-player
            v-pre
            src="/animations/user.json"
            background="transparent"
            speed="1"
            autoplay
            style="width: 300px; height: 150px; display: inline;"
          ></lottie-player>
        </div>

        <h1 class="d-none">
          PROFILE
        </h1>

        <div class="mb-5 mt-10">
          <h2 class="text-overline primary--text">Email:</h2>
          <p class="font-weight-bold">{{ $store.state.user.email }}</p>
        </div>

        <div class="mb-5">
          <h2 class="text-overline primary--text">Plan:</h2>
          <div v-if="!$store.getters.ifPremium">
            <p class="font-weight-bold">FREE PLAN</p>
            <div class="text-right">
              <v-btn text color="grey" to="/pricing">UPGRADE</v-btn>
            </div>
          </div>
          <div v-else>
            <p>
              {{ $store.state.user.premium_plan }} <br />
              <span class="grey--text text-caption">
                <span v-if="premium_status == 'active'">
                  Your subscription will be renewed on {{ premium_until }}
                </span>
                <span v-else-if="premium_status == 'cancelled'">
                  Your subscription's is cancelled. It ends on {{ premium_until }}
                </span>
                <span v-else-if="premium_status == 'failed'">
                  Unfortunately, there was a problem charging your payment preference, so your
                  premium membership is ended.
                </span>
                <span v-else-if="premium_status == 'refunded'">
                  Your subscription's is cancelled and your last payment has been refunded.
                </span>
              </span>
            </p>
            <div v-if="premium_status == 'active'">
              <div class="text-right">
                <v-btn
                  text
                  color="grey"
                  target="_blank"
                  :href="$store.state.user.premium_update_url"
                >
                  UPDATE PAYMENT INFORMATION
                </v-btn>
              </div>
              <div class="text-right">
                <v-btn
                  text
                  color="grey"
                  target="_blank"
                  :href="$store.state.user.premium_cancel_url"
                >
                  UNSUBSCRIBE
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <div class="mb-5" v-if="!$store.getters.ifPremium">
          <h2 class="text-overline primary--text">Usage:</h2>
          <v-progress-linear
            :value="data_points_usage_percentage"
            color="primary"
            height="25"
            class="mb-4 mt-2"
            rounded
          >
            <template v-slot="{ value }">
              <!-- prettier-ignore -->
              <span class="mr-3 overline font-weight-bold">URLS + FOLDERS</span>
              <strong class="overline">
                {{ $store.getters.data_points_usage }} /
                {{ $store.getters.data_points_limit }}
                <!-- prettier-ignore -->
                <span class="ml-1">
                  ({{ data_points_usage_percentage.toFixed(0)}}%)
                </span>
              </strong>
            </template>
          </v-progress-linear>
        </div>

        <div class="mb-5 mt-10">
          <h2 class="text-overline primary--text">newsletter:</h2>
          <v-switch
            color="primary"
            :loading="$store.state.user.newsletter_loading"
            :disabled="$store.state.user.newsletter_loading"
            :input-value="$store.state.user.newsletter"
            @change="newsletterChange"
            :false-value="false"
            label="I accept to get emails about product updates, new features, discounts and campaigns"
          ></v-switch>
        </div>

        <div class="mb-5 mt-10">
          <h2 class="text-overline primary--text">SECURITY:</h2>

          <div class="mt-3 text-center" v-if="!$store.state.user.encryption">
            <p class="text-left">
              Secure your data with end-to-end encryption via setting your Master Password. Which
              means that, your data will never reach our servers in their raw form. Your data will
              be encrypted and decrypted only on your devices. You need to enter your Master Key in
              each device you use.
            </p>
            <v-btn color="success" @click="activateEncryption" outlined text class="mx-auto">
              Activate End-to-End encryption
            </v-btn>
          </div>

          <div v-else>
            <p>Your data is end-to-end encrypted.</p>
            <div class="text-right">
              <v-btn text color="grey" @click="clickReenterMasterPassword">
                re-enter master password
              </v-btn>
            </div>
            <div class="text-right mt-3">
              <v-btn text color="grey" @click="clickResetMasterPassword">
                reset master password
              </v-btn>
            </div>
            <div class="text-right mt-3">
              <v-btn text color="grey" @click="clickRegerateRecovery">
                regenerate recovery password
              </v-btn>
            </div>
          </div>
        </div>

        <div class="mb-10 mt-8">
          <h2 class="text-overline primary--text">apperance:</h2>
          <p>Customize the view according to your taste.</p>
          <div class="text-right">
            <v-btn
              text
              color="grey"
              @click="$store.commit('updateStateUser', { theme_modal: true })"
            >
              customize
            </v-btn>
          </div>
        </div>

        <v-divider class="mt-10"></v-divider>

        <div class="text-right mt-5">
          <v-btn text large color="error" @click="$store.dispatch('logout')">
            <v-icon color="error" class="mr-2">mdi-logout</v-icon>
            LOGOUT
          </v-btn>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "Profile",
  metaInfo() {
    return this.generateMeta({ name: "profile", path: this.$route.path });
  },
  methods: {
    newsletterChange(val) {
      console.log(val, "newsletterChange");
      this.$store.dispatch("newsletter", {
        subscribe: val,
      });
    },
    activateEncryption() {
      this.$store.dispatch("fullscreenFormMode", { mode: "initial_master" });
    },
    clickReenterMasterPassword() {
      this.$store.dispatch("fullscreenFormMode", { mode: "master_password" });
    },
    clickResetMasterPassword() {
      this.$store.dispatch("fullscreenFormMode", { mode: "reset_master_with_recovery" });
    },
    clickRegerateRecovery() {
      this.$store.dispatch("fullscreenFormMode", { mode: "reset_recovery_with_master" });
    },
  },
  computed: {
    data_points_usage_percentage() {
      // prettier-ignore
      return (100 * (this.$store.getters.data_points_usage / this.$store.getters.data_points_limit) )
    },
    premium_status() {
      return this.$store.state.user.premium_status;
    },
    premium_until() {
      return (
        this.$store.getters.ifPremium &&
        new Date(this.$store.state.user.premium_until.seconds * 1000).toLocaleString()
      );
    },
  },
};
</script>
